import script from "./EditCheckPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCheckPoint.vue?vue&type=script&setup=true&lang=js"

import "./EditCheckPoint.vue?vue&type=style&index=0&id=485aeb2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485aeb2e"]])

export default __exports__